import { render } from "./TrialEndDialog.vue?vue&type=template&id=6df515f2&scoped=true"
import script from "./TrialEndDialog.vue?vue&type=script&lang=js"
export * from "./TrialEndDialog.vue?vue&type=script&lang=js"

import "./TrialEndDialog.vue?vue&type=style&index=0&id=6df515f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6df515f2"

export default script